import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { PlatformAdminProvider } from "./lib/usePlatformAdmin";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <PlatformAdminProvider>
          <App />
          <Toaster theme="dark" position="top-right" richColors />
        </PlatformAdminProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
